import { isEmpty } from 'ramda'
import { createSelector } from 'reselect'

const getCurrentOrganization = state => state.expediaCurrentOrganization
const getOrganizations = state => state.expediaOrganizations

export const selectCurrentOrganization = createSelector(
    getCurrentOrganization,
    currentOrganization => currentOrganization || ''
)

export const selectOrganizationList = createSelector(getOrganizations, organizations => {
    if (!(isEmpty(organizations.entities) || isEmpty(organizations.result))) {
        const items = organizations.entities.organizations
        return organizations.result.map(id => items[id])
    } else {
        return []
    }
})



// WEBPACK FOOTER //
// ./src/selectors/expediaSelectors/expediaCurrentOrganization.js